





































import Vue from 'vue';
import Spinner from '@/components/common/Spinner.vue';
import PairingProgressIndicator from './PairingProgressIndicator.vue';

import { prototype } from 'stream';
import { setInterval } from 'timers';
import DeviceType from '@/enums/DeviceType';
export default Vue.extend({
  name: 'ConnectingPage',
  components: {
    Spinner,
    PairingProgressIndicator,
  },
  data() {
    return {
      progressStep: 1,
    };
  },
  mounted() {
    setInterval(() => {
      switch (this.$store.state.pairingStatus.type) {
        case 'waitingForCredentials':
        case 'encryptingCredentials':
        case 'connectingToTheLight':
        case 'sendingCredentials':
          this.progressStep = 1;
          break;
        case 'waitingDeviceToConnectToTheWiFi':
          this.progressStep = 2;
          break;
        case 'creatingDeviceInCloud':
          this.progressStep = 3;
          break;
        case 'finishingPairing':
          this.progressStep = 4;
          break;
      }
    }, 1500);
  },
  computed: {
    statusMessage(): string {
      const status = this.$store.state.pairingStatus;
      switch (status.type) {
        case 'waitingForCredentials':
        case 'encryptingCredentials':
        case 'connectingToTheLight':
          return Vue.i18n.translate('Initiating_Connection') || '';
        case 'sendingCredentials':
          return Vue.i18n.translate('Sending_Credentials') || '';
        case 'waitingDeviceToConnectToTheWiFi':
          switch (this.$store.state.deviceType) {
            case DeviceType.Light:
              return Vue.i18n.translate('Waiting_Light_Connect_To_Wifi') || '';
            case DeviceType.Plug:
              return Vue.i18n.translate('Waiting_Plug_Connect_To_Wifi') || '';
            case DeviceType.WiFiSwitch:
              return (
                Vue.i18n.translate('Waiting_WiFi_Switch_Connect_To_Wifi') || ''
              );
          }
        case 'creatingDeviceInCloud':
          switch (this.$store.state.deviceType) {
            case DeviceType.Light:
              return Vue.i18n.translate('Creating_Light_In_Cloud') || '';
            case DeviceType.Plug:
              return Vue.i18n.translate('Creating_Plug_In_Cloud') || '';
            case DeviceType.WiFiSwitch:
              return Vue.i18n.translate('Creating_WiFi_Switch_In_Cloud') || '';
          }
        case 'finishingPairing':
          return Vue.i18n.translate('All_Done') || '';
      }
      return '';
    },
    deviceType(): DeviceType {
      return this.$store.state.deviceType;
    },
    progressClass(): string {
      const status = this.$store.state.pairingStatus;
      switch (status.type) {
        case 'waitingForCredentials':
        case 'encryptingCredentials':
        case 'connectingToTheLight':
        case 'sendingCredentials':
          return 'circle-quarter';
        case 'waitingDeviceToConnectToTheWiFi':
          return 'circle-half';
        case 'creatingDeviceInCloud':
          return 'circle-three-quarters';
        case 'finishingPairing':
          return 'circle-full';
      }
      return '';
    },
    spinnerIsVisible(): boolean {
      return !this.stuckHintIsVisible || window.innerHeight >= 600;
    },
    stuckHintIsVisible(): boolean {
      const status = this.$store.state.pairingStatus;
      switch (status.type) {
        case 'sendingCredentials':
        case 'waitingDeviceToConnectToTheWiFi':
        case 'creatingDeviceInCloud':
        case 'finishingPairing':
          return status.hintTimeoutReached;
        default:
          return false;
      }
    },
    stuckHintTitle(): string {
      const status = this.$store.state.pairingStatus;
      switch (status.type) {
        case 'sendingCredentials':
        case 'waitingDeviceToConnectToTheWiFi':
        case 'creatingDeviceInCloud':
        case 'finishingPairing':
          return Vue.i18n.translate('StuckHint_Title') || '';
        default:
          return '';
      }
    },
    stuckHintMessage(): string {
      const status = this.$store.state.pairingStatus;
      switch (status.type) {
        case 'sendingCredentials':
        case 'waitingDeviceToConnectToTheWiFi':
          return Vue.i18n.translate('StuckHint_MessageDeviceWifi') || '';
        case 'creatingDeviceInCloud':
        case 'finishingPairing':
          return Vue.i18n.translate('StuckHint_MessageHomeWifi') || '';
        default:
          return '';
      }
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ConnectingPage.vue